<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              골프클럽 관리
            </div>
          </section>
          <section class="section02">
            <div class="object01"></div>
            <div class="object02">
              <div class="form">
                <div class="select">
                  <div class="formSelect" ref="select01">
                    <div class="formSelectList" @click="openSelect01">
                      <input
                        type="text"
                        v-model="activeStatusName"
                        placeholder="클럽 상태"
                        readonly
                      />
                    </div>
                    <div class="formSelectPopup select01">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input
                                    type="text"
                                    placeholder="검색어를 입력하세요."
                                  />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li
                                    v-for="activeStatusInfo in activeStatusList"
                                    :key="activeStatusInfo.name"
                                  >
                                    <label>
                                      <input
                                        type="radio"
                                        v-model="selectActiveStatus"
                                        :value="activeStatusInfo.code"
                                        v-on:change="confirmActiveStatus"
                                      />
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>{{ activeStatusInfo.name }}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="select managementStatus">
                  <div class="formSelect" ref="select02">
                    <div class="formSelectList" @click="openSelect02">
                      <input
                        type="text"
                        v-model="manageStatusName"
                        placeholder="운영상태"
                        readonly
                      />
                    </div>
                    <div class="formSelectPopup select02">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input
                                    type="text"
                                    placeholder="검색어를 입력하세요."
                                  />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li
                                    v-for="manageStatusInfo in manageStatusList"
                                    :key="manageStatusInfo.name"
                                  >
                                    <label>
                                      <input
                                        type="radio"
                                        v-model="selectManageStatus"
                                        :value="manageStatusInfo.code"
                                        v-on:change="confirmManageStatus"
                                      />
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>{{ manageStatusInfo.name }}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="select aplStatus">
                  <div class="formSelect" ref="select03">
                    <div class="formSelectList" @click="openSelect03">
                      <input
                        type="text"
                        v-model="aplStatusName"
                        placeholder="APL상태"
                        readonly
                      />
                    </div>
                    <div class="formSelectPopup select03">
                      <div class="formSelectPopup-container">
                        <div class="outer">
                          <div class="inner">
                            <div class="formSelectPopup-box">
                              <div class="formSelectPopup-zone">
                                <div class="formSelectPopup-header">
                                  <input
                                    type="text"
                                    placeholder="검색어를 입력하세요."
                                  />
                                </div>
                                <ul class="formSelectPopup-body">
                                  <li
                                    v-for="aplStatusInfo in aplStatusList"
                                    :key="aplStatusInfo.name"
                                  >
                                    <label>
                                      <input
                                        type="radio"
                                        v-model="selectAplStatus"
                                        :value="aplStatusInfo.code"
                                        v-on:change="confirmAplStatus"
                                      />
                                      <input type="checkbox" />
                                      <i></i>
                                      <span>{{ aplStatusInfo.name }}</span>
                                    </label>
                                  </li>
                                </ul>
                                <div class="formSelectPopup-footer">
                                  <button class="formSelectPopup-cancel">
                                    취소
                                  </button>
                                  <!-- 비활성(Attribute) : disabled -->
                                  <button class="formSelectPopup-confirm">
                                    확인
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input">
                  <input
                    type="text"
                    v-model="clubName"
                    placeholder="검색어를 입력하세요"
                    v-on:keyup.enter="setSearchValue"
                  />
                </div>
                <div class="search" @click="setSearchValue">
                  <button>
                    검색
                  </button>
                </div>
              </div>
            </div>
            <div class="object03">
              <!--<button class="registration" @click="moveMenu('/SE003')">
                등록하기
              </button>-->
            </div>
          </section>
          <section class="section03 scroll-body">
            <!-- 데이터 없을때(Class) : none -->
            <div
              class="object01 dev_headerLine"
              :class="pagingInfo.totalCount === 0 ? 'none' : ''"
            >
              <div class="table thead">
                <!-- 헤더 고정 활성(Class) : active / x축 스크롤 이동 값(Style) : x축 스크롤 이동한 값 만큼 margin-left 마이너스 값 -->
                <div class="fixed grid">
                  <div class="unit">
                    전체 <span>{{ pagingInfo.totalCount }}</span
                    >건
                  </div>
                  <div class="contain">
                    <table class="dev_aplList">
                      <colgroup>
                        <col class="club" />
                        <col class="managementStatus" />
                        <col class="aplStatus" />
                        <col class="status" />
                        <col class="area" />
                        <col class="pinSize" />
                        <col class="offDay" />
                        <col class="offWhether" />
                        <col class="pinChangeSystem" />
                        <col class="remark" />
                      </colgroup>
                      <thead>
                        <tr>
                          <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                          <th
                            rowspan="2"
                            class="club sort"
                            @click="headerSort('club', 'club_name')"
                          >
                            <div class="item">
                              골프클럽명
                            </div>
                          </th>
                          <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                          <th
                            rowspan="2"
                            class="managementStatus sort"
                            @click="
                              headerSort('managementStatus', 'manage_status')
                            "
                          >
                            <div class="item">
                              운영 상태
                            </div>
                          </th>
                          <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                          <th
                            rowspan="2"
                            class="aplStatus sort"
                            @click="headerSort('aplStatus', 'apl_status')"
                          >
                            <div class="item">
                              APL 지원 상태
                            </div>
                          </th>
                          <!-- 정렬 : sort / 내림차순 : descending / 오름차순 : ascending -->
                          <th
                            rowspan="2"
                            class="status sort"
                            @click="headerSort('status', 'active_status')"
                          >
                            <div class="item">
                              상태
                            </div>
                          </th>
                          <th colspan="6" class="golfInfo">
                            <div class="item">
                              골프장 정보
                            </div>
                          </th>
                        </tr>
                        <tr>
                          <th class="area">
                            <div class="item">
                              지역
                            </div>
                          </th>
                          <th class="pinSize">
                            <div class="item">
                              핀 사이즈(mm)
                            </div>
                          </th>
                          <th class="offDay">
                            <div class="item">
                              휴장일
                            </div>
                          </th>
                          <th class="offWhether">
                            <div class="item">
                              휴장 여부
                            </div>
                          </th>
                          <th class="pinChangeSystem">
                            <div class="item">
                              핀 교체 방식
                            </div>
                          </th>
                          <th class="remark">
                            <div class="item">
                              특이사항
                            </div>
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
              </div>
              <div class="table tbody">
                <div class="contain">
                  <table>
                    <colgroup>
                      <col class="club" />
                      <col class="managementStatus" />
                      <col class="aplStatus" />
                      <col class="status" />
                      <col class="area" />
                      <col class="pinSize" />
                      <col class="offDay" />
                      <col class="offWhether" />
                      <col class="pinChangeSystem" />
                      <col class="remark" />
                    </colgroup>
                    <tbody>
                      <!-- 비활성화(Class) : disabled -->
                      <tr
                        v-for="clubInfo in clubInfoList"
                        :class="
                          clubInfo.active_status === 'inactive'
                            ? 'disabled'
                            : ''
                        "
                        :key="clubInfo.ccode"
                        @click="moveDetail(clubInfo.ccode)"
                      >
                        <td class="club">
                          {{ clubInfo.club_name }}
                        </td>
                        <td class="managementStatus">
                          {{
                            clubInfo.manage_status === 'active'
                              ? '운영중'
                              : '운영 예정'
                          }}
                        </td>
                        <td class="aplStatus">
                          {{
                            aplStatusList.find(
                              it => it.code === clubInfo.apl_status
                            ).name
                          }}
                        </td>
                        <td class="status">
                          {{
                            activeStatusList.find(
                              it => it.code === clubInfo.active_status
                            ).name
                          }}
                        </td>
                        <td class="area">
                          {{
                            getRegion(
                              setRegionCode(
                                clubInfo.ccode,
                                clubInfo.region_code
                              )
                            )
                          }}
                        </td>
                        <td class="pinSize">
                          {{ confirmPinSize(clubInfo.pin_size) }}
                        </td>
                        <td class="offDay">
                          {{
                            makeText(
                              clubInfo.holiday_start,
                              clubInfo.holiday_end,
                              clubInfo.holiday_week_ju,
                              clubInfo.holiday_week
                            )
                          }}
                        </td>
                        <td class="offWhether">
                          {{ isTodayOff(clubInfo) ? 'O' : 'X' }}
                        </td>
                        <td class="pinChangeSystem">
                          {{ clubInfo.pin_change }}
                        </td>
                        <td class="remark">
                          {{ clubInfo.uniqueness }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody class="none">
                      <tr>
                        <td colspan="10">
                          데이터가 없습니다.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
          <section class="section04">
            <div class="object01">
              <!-- 이전 활성 : prevActive / 다음 활성 : nextActive -->
              <div class="paging" :class="pagingInfo.pageButtonClass">
                <div class="prev" @click="prevPage">
                  <div class="item">
                    이전
                  </div>
                </div>
                <ul class="number">
                  <!-- 활성 : active -->
                  <li
                    v-for="i in this.pagingInfo.endPage -
                      this.pagingInfo.startPage +
                      1"
                    :key="i"
                    :class="
                      i + pagingInfo.startPage - 1 === pagingInfo.pageNo
                        ? 'active'
                        : ''
                    "
                    @click="movePage(i + pagingInfo.startPage - 1)"
                  >
                    {{ i + pagingInfo.startPage - 1 }}
                  </li>
                </ul>
                <div class="next" @click="nextPage">
                  <div class="item">
                    다음
                  </div>
                </div>
              </div>
            </div>
            <div
              class="object02"
              v-if="pagingInfo.totalCount !== clubInfoList.length"
              @click="moreData"
            >
              더보기
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li
                      v-for="activeStatusInfo in activeStatusList"
                      :key="activeStatusInfo.name"
                    >
                      <label>
                        <input
                          type="radio"
                          v-model="selectActiveStatus"
                          :value="activeStatusInfo.code"
                          v-on:change="confirmActiveStatus"
                        />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ activeStatusInfo.name }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li
                      v-for="manageStatusInfo in manageStatusList"
                      :key="manageStatusInfo.name"
                    >
                      <label>
                        <input
                          type="radio"
                          v-model="selectManageStatus"
                          :value="manageStatusInfo.code"
                          v-on:change="confirmManageStatus"
                        />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ manageStatusInfo.name }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select03">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="검색어를 입력하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li
                      v-for="aplStatusInfo in aplStatusList"
                      :key="aplStatusInfo.name"
                    >
                      <label>
                        <input
                          type="radio"
                          v-model="selectAplStatus"
                          :value="aplStatusInfo.code"
                          v-on:change="confirmAplStatus"
                        />
                        <input type="checkbox" />
                        <i></i>
                        <span>{{ aplStatusInfo.name }}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'

import { settingService, userService } from '../../router'

export default {
  name: 'SE001',
  data () {
    return {
      clubName: '',
      activeStatus: '',
      activeStatusName: '',
      selectActiveStatus: null,
      activeStatusList: [
        { name: '전체', code: '' },
        { name: '활성화', code: 'active' },
        { name: '비활성화', code: 'inactive' }
      ],
      manageStatus: '',
      manageStatusName: '',
      selectManageStatus: null,
      manageStatusList: [
        { name: '전체', code: '' },
        { name: '운영중', code: 'active' },
        { name: '운영예정', code: 'inactive' }
      ],
      aplStatus: '',
      aplStatusName: '',
      selectAplStatus: null,
      aplStatusList: [
        { name: '전체', code: '' },
        { name: '서비스중', code: 'service' },
        { name: '점검중', code: 'check' },
        { name: '준비중', code: 'ready' }
      ],
      clubRegion: [
        { name: '경기/인천', code: 1 },
        { name: '충청북도', code: 10 },
        { name: '충청남도', code: 11 },
        { name: '전라도', code: 20 },
        { name: '경상북도', code: 30 },
        { name: '경상남도', code: 31 },
        { name: '강원도', code: 40 },
        { name: '제주도', code: 50 }
      ],
      clubInfoList: [],
      pinSize: '',
      pinSizeSize: '',
      selectPinSize: null,
      pinSizeArr: [
        { size: '13', code: '0' },
        { size: '20', code: '1' },
        { size: '27', code: '2' }
      ],
      orderTarget: 'club_name',
      orderValue: 'asc',
      pagingInfo: {
        totalCount: 0,
        pageSize: 15,
        pageNo: 1,
        maxPage: 5,
        pageGroup: 5,
        startPage: 1,
        endPage: 5,
        prev: false,
        next: true,
        pageButtonClass: 'nextActive'
      }
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
      if (this.userInfo.userRole === 'ClubManager') {
        this.$router.push('/SE002?ccode=' + this.userInfo.ccode)
      }
    })
  },
  mounted: function () {
    this.setData()
    window.addEventListener('resize', this.resizeEvt)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.resizeEvt)
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    setData: function () {
      settingService
        .getClubInfoList(
          this.pagingInfo.pageNo,
          this.pagingInfo.pageSize,
          this.activeStatus,
          this.manageStatus,
          this.aplStatus,
          this.searchValue,
          this.orderTarget,
          this.orderValue
        )
        .then(response => {
          this.pagingInfo.totalCount = response.data.totalCount
          this.clubInfoList = response.data.clubInfoList
          this.setPagination()
        })
        .catch(error => {
          console.log('getClubInfoList.err.===>', error)
        })
    },
    setSearchValue: function () {
      this.searchValue = this.clubName
      this.pagingInfo.pageNo = 1
      this.setData()
    },
    confirmActiveStatus: function () {
      this.activeStatus = this.selectActiveStatus
      this.activeStatusName = this.activeStatusList.find(
        it => it.code === this.activeStatus
      ).name
      this.pagingInfo.pageNo = 1
      this.setData()
      this.closeSelectAll()
    },
    confirmManageStatus: function () {
      this.manageStatus = this.selectManageStatus
      this.manageStatusName = this.manageStatusList.find(
        it => it.code === this.manageStatus
      ).name
      this.pagingInfo.pageNo = 1
      this.setData()
      this.closeSelectAll()
    },
    confirmAplStatus: function () {
      this.aplStatus = this.selectAplStatus
      this.aplStatusName = this.aplStatusList.find(
        it => it.code === this.aplStatus
      ).name
      this.pagingInfo.pageNo = 1
      this.setData()
      this.closeSelectAll()
    },
    getRegion: function (regionCode) {
      if (!regionCode) return ''
      return this.clubRegion.find(it => it.code === regionCode).name
    },
    makeText: function (start, end, weekJu, week) {
      return this.makeOffDayTxt(start, end, weekJu, week)
    },
    isHolidaysNotNull: function (start, end) {
      if (start && end) {
        return true
      }
    },
    moreData: function () {
      this.pagingInfo.pageSize += 15
      this.setData()
    },
    moveDetail: function (ccode) {
      this.$router.push('/SE002?ccode=' + ccode)
    },
    movePage: function (pageNo) {
      this.pagingInfo.pageNo = pageNo
      this.setData()
    },
    prevPage: function () {
      if (this.pagingInfo.prev) {
        if (this.pagingInfo.startPage > 1) {
          this.pagingInfo.pageNo = this.pagingInfo.startPage - 1
          this.setData()
        }
      }
    },
    nextPage: function () {
      if (this.pagingInfo.next) {
        if (this.pagingInfo.endPage < this.pagingInfo.maxPage) {
          this.pagingInfo.pageNo = this.pagingInfo.endPage + 1
          this.setData()
        }
      }
    },
    headerSort: function (target, field) {
      if (
        document.querySelector('.dev_aplList thead tr th.ascending') !== null
      ) {
        document
          .querySelector('.dev_aplList thead tr th.ascending')
          .classList.remove('ascending')
      }
      if (
        document.querySelector('.dev_aplList thead tr th.descending') !== null
      ) {
        document
          .querySelector('.dev_aplList thead tr th.descending')
          .classList.remove('descending')
      }
      if (this.orderTarget === field) {
        if (this.orderValue === 'asc') {
          this.orderValue = 'desc'
          document
            .querySelector('.dev_aplList thead tr th.' + target)
            .classList.add('descending')
        } else {
          this.orderValue = 'asc'
          document
            .querySelector('.dev_aplList thead tr th.' + target)
            .classList.add('ascending')
        }
      } else {
        document
          .querySelector('.dev_aplList thead tr th.' + target)
          .classList.add('ascending')
        this.orderTarget = field
        this.orderValue = 'asc'
      }
      this.setData()
    },
    setPagination: function () {
      if (this.pagingInfo.totalCount === 0) {
        this.pagingInfo.startPage = 1
        this.pagingInfo.endPage = 1
        this.pagingInfo.maxPage = 1
        this.pagingInfo.prev = false
        this.pagingInfo.next = false
        this.pagingInfo.pageButtonClass = ''
      } else {
        this.pagingInfo.startPage =
          Math.floor(
            Math.floor(
              (this.pagingInfo.pageNo - 1) / this.pagingInfo.pageGroup
            ) * this.pagingInfo.pageGroup
          ) + 1
        this.pagingInfo.endPage =
          this.pagingInfo.startPage + this.pagingInfo.pageGroup - 1
        this.pagingInfo.maxPage = Math.ceil(
          this.pagingInfo.totalCount / this.pagingInfo.pageSize
        )
        if (this.pagingInfo.endPage > this.pagingInfo.maxPage) {
          this.pagingInfo.endPage = this.pagingInfo.maxPage
        }
        this.pagingInfo.pageButtonClass = ''
        if (
          this.pagingInfo.startPage > 1 &&
          this.pagingInfo.endPage < this.pagingInfo.maxPage
        ) {
          this.pagingInfo.prev = true
          this.pagingInfo.next = true
          this.pagingInfo.pageButtonClass = 'prevActive nextActive'
        } else if (this.pagingInfo.startPage > 1) {
          this.pagingInfo.prev = true
          this.pagingInfo.next = false
          this.pagingInfo.pageButtonClass = 'prevActive'
        } else if (this.pagingInfo.endPage < this.pagingInfo.maxPage) {
          this.pagingInfo.prev = false
          this.pagingInfo.next = true
          this.pagingInfo.pageButtonClass = 'nextActive'
        }
      }
    },
    resizeEvt: function () {
      if (this.mobileFlag) {
        if (window.innerWidth > 1279) {
          this.mobileFlag = false
          this.pagingInfo.pageSize = 15
          this.setData()
        }
      } else {
        if (window.innerWidth < 1280) {
          this.mobileFlag = true
          this.pagingInfo.pageNo = 1
          this.activeStatus = ''
          this.activeStatusName = ''
          this.selectActiveStatus = null
          this.manageStatus = ''
          this.manageStatusName = ''
          this.selectManageStatus = null
          this.aplStatus = ''
          this.aplStatusName = ''
          this.selectAplStatus = null
          this.searchValue = ''
          this.setData()
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/setting/SE001.vue